import React,{useState,useEffect} from 'react';
import {Typography, Grid } from '@mui/material';
import AuthUser from '../../../Components/Auth/AuthUser';
import { useDispatch } from 'react-redux';
import { fetchData } from '../../../redux/apiSlice';
import Moment from 'moment';
import formatPhoneNumber from '../../../../src/Components/Formats/PhoneNumberValidation';

let companyname;
function  CompanyExpandedRow(props) {
    const dispatch = useDispatch();
    console.log(props.companyId);
return (
<>

        <Grid container spacing={1} sx={{ marginBottom: 3 }}>
              <Grid item xs={3}>
                  <Typography variant="body2" >Affiliate Name :</Typography>
                  <Typography variant="subtitle1" fontWeight="bold" className="common-value">{props.companyId ?  (`${props.companyId.first_name} ${props.companyId.last_name}`) : '' }</Typography>
              </Grid>
              <Grid item xs={3}>
                  <Typography variant="body2" >Phone :</Typography>
                  <Typography variant="subtitle1" fontWeight="bold" className="common-value">{props.companyId ? props.companyId.phone_no  ? formatPhoneNumber(props.companyId.phone_no) : "N/A": "N/A"}</Typography>
              </Grid>
              <Grid item xs={3}>
                  <Typography variant="body2" >Communication Email :</Typography>
                  <Typography variant="subtitle1" fontWeight="bold" className="common-value">{props.companyId ? props.companyId.communication_email  : 'N/A' }</Typography>
              </Grid>
              <Grid item xs={3}>
                  <Typography variant="body2" >City :</Typography>
                  <Typography variant="subtitle1" fontWeight="bold" className="common-value">{props.companyId ?  props.companyId.city : 'N/A' }</Typography>
              </Grid>
              <Grid item xs={3}>
                  <Typography variant="body2" >State :</Typography>
                  <Typography variant="subtitle1" fontWeight="bold" className="common-value">{props.companyId ? props.companyId.state_code : 'N/A' }</Typography>
              </Grid>
              <Grid item xs={3}>
                  <Typography variant="body2" >Approval Date :</Typography>
                  <Typography variant="subtitle1" fontWeight="bold" className="common-value">{props.companyId ? props.companyId.approved_date? Moment(props.companyId.approved_date).format('MM-DD-YYYY') : 'N/A': 'N/A'}</Typography>
              </Grid>
              <Grid item xs={3}>
                  <Typography variant="body2" >Referral Code :</Typography>
                  <Typography variant="subtitle1" fontWeight="bold" className="common-value">{props.companyId ? props.companyId.referral_code : 'N/A'}</Typography>
              </Grid>
              <Grid item xs={3}>
                  <Typography variant="body2" >Referred By :</Typography>
                  <Typography variant="subtitle1" fontWeight="bold" className="common-value">{props.companyId ? props.companyId.referred_by_name?props.companyId.referred_by_name:props.companyId.referred_by :"N/A" }</Typography>
              </Grid>
              
        </Grid> 

</>
    );
}


export default CompanyExpandedRow;